import React from 'react';
import '../App.css';

const MobileContent = (props) =>{
    return(
          <div className="mobile-content">
            <h3> Contact</h3>
            <p>{props.mobileContact.contactInfo && props.mobileContact.contactInfo.map((item,index) => {
              if (item !== "") {
                return <p style={{textTransform: 'uppercase', marginBottom: '5px'}}> {item}</p>
              }
            })}</p>
            <p>{props.mobileContact.email}</p>
            <p>{props.mobileContact.instagram}</p>
            <p>{props.mobileContact.phone}</p>
          </div>
    )

}

export default MobileContent;



// WEBPACK FOOTER //
// ./src/Contact/MobileContent.js